export const UPDATE_USER = 'UPDATE_USER';
export const CHANGE_EMAIL = 'CHANGE_EMAIL';
export const CONFIRM_CHANGE_EMAIL = 'CONFIRM_CHANGE_EMAIL';
export const DECRYPT_RESTORE_LINK = 'DECRYPT_RESTORE_LINK';

export const USER = 'USER';
export const UPDATE = 'UPDATE';
export const UPDATE_EMAIL = 'UPDATE_EMAIL';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const CLEAR = 'CLEAR';
